module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_CN.7c67013f.txt";